import { render } from "./goodsManage.vue?vue&type=template&id=0d4ccc70"
import script from "./goodsManage.vue?vue&type=script&lang=js"
export * from "./goodsManage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__